import hex from 'crypto-js/enc-hex';
import sha256 from 'crypto-js/sha256';
var encodeSha256 = function encodeSha256(text) {
  return text ? hex.stringify(sha256(text)) : '';
};
export { encodeSha256 };